import { api } from "@/lib/api";

const DEVICE_KEY = "vsk_device";

export function deviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 64);
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

let queue = [];
let timer = null;

export function trackFeed(event) {
  queue.push(event);
  if (queue.length >= 20) flushFeed();
  else if (!timer) timer = setTimeout(flushFeed, 4000);
}

export function flushFeed() {
  if (timer) { clearTimeout(timer); timer = null; }
  if (!queue.length) return;
  const events = queue.splice(0, 60);
  api.post("/feed/events", { device_id: deviceId(), events }).catch(() => {});
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", flushFeed);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flushFeed(); });
}

export const SLOGANS = [
  { big: "A million products.", small: "Always live.", cta: "Browse everything", to: "/discover" },
];
